import { SxProps, Theme } from '@mui/material/styles';

export const buttonStyles: Record<string, SxProps<Theme>> = {
  gradient: {
    textTransform: 'uppercase',
    background: 'linear-gradient(to right, #9A4FFF, #507FFF)',
    color: "#ffff",
    borderRadius: "5px",
    '&:hover': {
      background: 'linear-gradient(to right, #9A4FFF, #507FFF)'
    }
  },
  cancel: {
    textTransform: 'uppercase',
    background: '#C2C2C2',
    color: "black",
    borderRadius: "5px",
  },
};

